const COLOR_BY_TYPE: Record<string, string> = {
  // mango-api PhoneNumber.Type
  caller_id: 'purple',
  sms_only: 'teal',
  standard: 'gray',
  temporary: 'orange',
  // mistaken legacy values (should not appear from API; kept for old rows/UI)
  fax: 'purple',
  efax: 'blue',
  sms: 'teal',
}

export function getTypeColorPalette(type: string | undefined | null): string {
  if (!type) return 'gray'
  return COLOR_BY_TYPE[type.toLowerCase()] ?? 'gray'
}
